<template>
  <page-header-wrapper>
    <div class="business-page erp-list-page baidao-list-page guide-price-page">
      <header class="page-heading">
        <h2>销售指导价</h2>
        <p>按 SKU 和仓库维护销售价格，销售订单将读取当前启用的指导价。</p>
      </header>

      <section class="query-panel erp-search-card">
        <div class="query-label">
          <strong>商品 SKU</strong>
          <span>请先选择需要维护价格的 SKU</span>
        </div>
        <a-select
          v-model="selectedSkuId"
          show-search
          allow-clear
          :filter-option="false"
          style="width:420px"
          placeholder="搜索 SKU 编码或名称"
          @focus="searchSku('')"
          @search="searchSku">
          <a-select-option v-for="sku in skuList" :key="sku.id" :value="sku.id">{{ sku.skuCode }} · {{ sku.skuName }}</a-select-option>
        </a-select>
      </section>

      <section class="table-section erp-table-card">
        <guide-price-editor :sku-id="selectedSkuId" />
      </section>
    </div>
  </page-header-wrapper>
</template>

<script>
import GuidePriceEditor from '@/views/erp/product/GuidePriceEditor.vue'
import { skuOptions } from '@/api/erp/salesOrder'

export default {
  name: 'ErpGuidePrice',
  components: { GuidePriceEditor },
  data () { return { selectedSkuId: undefined, skuList: [] } },
  created () { this.searchSku('') },
  methods: {
    searchSku (keyword) {
      skuOptions(keyword).then(res => {
        const options = res.data || []
        const current = this.skuList.find(sku => String(sku.id) === String(this.selectedSkuId))
        this.skuList = current && !options.some(sku => String(sku.id) === String(current.id)) ? [current, ...options] : options
      })
    }
  }
}
</script>

<style scoped>
.business-page{background:#fcfdff;border:1px solid #e4e9ef;border-radius:8px;padding:22px 24px;min-height:630px}.page-heading{margin-bottom:22px}.page-heading h2{font-size:19px;font-weight:650;color:#263445;margin:0 0 5px}.page-heading p{font-size:13px;color:#68788b;margin:0}.query-panel{display:flex;align-items:center;justify-content:space-between;gap:24px;background:#f5f7fa;border:1px solid #e4e9ef;border-radius:6px;padding:16px;margin-bottom:22px}.query-label{display:flex;flex-direction:column;gap:3px}.query-label strong{font-size:14px;color:#263445}.query-label span{font-size:12px;color:#768599}.table-section{min-height:360px}@media(max-width:900px){.business-page{padding:16px}.query-panel{align-items:stretch;flex-direction:column}.query-panel /deep/ .ant-select{width:100%!important}}
</style>
